import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import AuthUnavailableScreen from './AuthUnavailableScreen';
import { protectedRouteView } from '@/lib/auth-session';

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading, connectionError, checkAuth, logout } = useAuth();
  const location = useLocation();

  const view = protectedRouteView({ isAuthenticated, isLoading, connectionError });

  // Sessió desada però sense poder-la comprovar (sense xarxa, deploy): ni login ni spinner etern.
  if (view === 'unavailable') {
    return (
      <AuthUnavailableScreen
        retrying={isLoading}
        onRetry={() => {
          void checkAuth();
        }}
        onSignOut={() => {
          void logout();
        }}
      />
    );
  }

  // Mientras se verifica la autenticación, mostrar loading
  if (view === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-12 w-12 animate-spin text-blue-600" />
          <p className="text-gray-600">Verificant autenticació...</p>
        </div>
      </div>
    );
  }

  // Si no está autenticado, redirigir al login
  if (view === 'login') {
    // Guardar la ruta actual para redirigir después del login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si está autenticado, mostrar el contenido protegido
  return <Outlet />;
}
